
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/how-aithon-works",
      function () {
        return require("private-next-pages/how-aithon-works.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/how-aithon-works"])
      });
    }
  